import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div className="relative border-y border-white/10 py-10 overflow-hidden select-none" data-testid="services-marquee" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-black uppercase tracking-tighter text-6xl md:text-8xl text-stroke px-6">
                  {item}
                </span>
                <span className="font-mono text-brand-light text-2xl px-2">//</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
